export const parseVersion = (value: string) => {
  const version = value.trim();
  try {
    if (version === '') {
      throw new Error('Version is empty.');
    }
    const versionArray = version.split('.').map(part => Number(part));
    if (
      versionArray.length === 3 &&
      versionArray[0] > -1 &&
      versionArray[1] > -1 &&
      versionArray[2] > -1
    ) {
      return versionArray;
    }
    throw new Error(`Version invalid: ${version}`);
  } catch (ex) {
    throw new Error('Failed version number');
  }
};
